var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8667 2.87539C27.7452 2.07742 27.3367 1.34862 26.7153 0.821108C26.0938 0.293597 25.3006 0.0022923 24.4794 0H3.3873C2.56605 0.0022923 1.77282 0.293597 1.15139 0.821108C0.529971 1.34862 0.12149 2.07742 0 2.87539L13.9333 11.7333L27.8667 2.87539Z",
    fill: "#0B4471"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4377 13.6555C14.2874 13.7508 14.1123 13.8015 13.9333 13.8015C13.7544 13.8015 13.5792 13.7508 13.4289 13.6555L0 5.13427V18.6395C0.000983501 19.5304 0.362322 20.3847 1.00473 21.0147C1.64715 21.6447 2.51816 21.9991 3.42667 22H24.44C25.3485 21.9991 26.2195 21.6447 26.8619 21.0147C27.5043 20.3847 27.8657 19.5304 27.8667 18.6395V5.13336L14.4377 13.6555Z",
    fill: "#0B4471"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.129601df38ab508382f1b59cc126fa65.svg";
export { ForwardRef as ReactComponent };